import React, { useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { HeroLeadForm } from "@/components/landing/HeroLeadForm";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { TrustBar } from "@/components/landing/TrustBar";
import { Industries } from "@/components/landing/Industries";
import { Features } from "@/components/landing/Features";
import { DeveloperApi } from "@/components/landing/DeveloperApi";
import { Chatbot } from "@/components/landing/Chatbot";
import { Bulk } from "@/components/landing/Bulk";
import { CRM } from "@/components/landing/CRM";
import { GreenTick } from "@/components/landing/GreenTick";
import { Pricing } from "@/components/landing/Pricing";
import { Comparison } from "@/components/landing/Comparison";
import { Results } from "@/components/landing/Results";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { FloatingActions } from "@/components/landing/FloatingActions";
import { SeoHead } from "@/components/SeoHead";
import { BRAND } from "@/lib/brand";

export default function Landing() {
  // All "Book Demo" CTAs across the site route to the official Calendly booking page.
  const openDemo = () => {
    if (typeof window !== "undefined") {
      window.open(BRAND.links.bookDemo, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <main data-testid="landing-page" className="bg-white text-slate-900 overflow-x-hidden w-full">
      <Navbar onBookDemo={openDemo} />
      <Hero onBookDemo={openDemo} />
      <HeroLeadForm />
      <TrustStrip />
      <TrustBar />
      <Industries />
      <Features />
      <Chatbot />
      <Bulk />
      <CRM />
      <DeveloperApi />
      <GreenTick onTalkToExpert={openDemo} />
      <Pricing onSelectPlan={openDemo} />
      <Comparison />
      <Results />
      <Testimonials />
      <FAQ />
      <FinalCTA onBookDemo={openDemo} />
      <Footer />
      <FloatingActions onBookDemo={openDemo} />
    </main>
  );
}
